import React from 'react';
import { motion } from 'framer-motion';
import { useForm } from 'react-hook-form';
import emailjs from '@emailjs/browser';

const Contact = () => {
  const { register, handleSubmit, formState: { errors }, reset } = useForm();

  const onSubmit = (data) => {
    emailjs.send(
      'service_qyjyign', // Replace with your EmailJS service ID
      'template_ch73nao', // Replace with your EmailJS template ID
      data,
      'uMUkZxw_eelOn49Mk' // Replace with your EmailJS public key
    )
      .then(() => {
        alert('Message sent successfully!');
        reset();
      })
      .catch((error) => {
        alert('Failed to send message: ' + error.text);
      });
  };

  return (
    <section id="contact" className="py-20 bg-gray-800">
      <div className="max-w-7xl mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-12 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-400">
          Contact Me
        </h2>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="max-w-lg mx-auto bg-gradient-to-br from-gray-700 to-gray-600 p-8 rounded-xl shadow-xl"
        >
          <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
            <div>
              <input
                type="text"
                placeholder="Your Name"
                {...register('name', { required: 'Name is required' })}
                className="w-full p-3 rounded-lg bg-gray-800 text-white border border-gray-600 focus:border-blue-400 outline-none transition-all"
              />
              {errors.name && <p className="text-red-400 text-sm mt-1">{errors.name.message}</p>}
            </div>
            <div>
              <input
                type="email"
                placeholder="Your Email"
                {...register('email', { 
                  required: 'Email is required',
                  pattern: { value: /^\S+@\S+$/i, message: 'Invalid email' }
                })}
                className="w-full p-3 rounded-lg bg-gray-800 text-white border border-gray-600 focus:border-blue-400 outline-none transition-all"
              />
              {errors.email && <p className="text-red-400 text-sm mt-1">{errors.email.message}</p>}
            </div>
            <div>
              <textarea
                placeholder="Your Message"
                {...register('message', { required: 'Message is required' })}
                className="w-full p-3 rounded-lg bg-gray-800 text-white border border-gray-600 focus:border-blue-400 outline-none transition-all h-32"
              />
              {errors.message && <p className="text-red-400 text-sm mt-1">{errors.message.message}</p>}
            </div>
            <button
              type="submit"
              className="w-full bg-gradient-to-r from-blue-500 to-purple-500 hover:from-blue-600 hover:to-purple-600 p-3 rounded-lg text-white font-semibold transition-all duration-300"
            >
              Send Message
            </button>
          </form>
        </motion.div>
      </div>
    </section>
  );
};

export default Contact;